exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._30ST8somYJlrS3nF51nuW9 .top-navigation{background-color:dycolor-internal(!header,@theme-white)}._30ST8somYJlrS3nF51nuW9 .desktop-dropdown .dropdown-menu .dropdown-item{color:dycolor-internal(!dropdown-color,@theme-dark-grey)}._30ST8somYJlrS3nF51nuW9 .desktop-dropdown .dropdown-menu .dropdown-item.selected,._30ST8somYJlrS3nF51nuW9 .desktop-dropdown .dropdown-menu .dropdown-item.active{color:dycolor-internal(!dropdown-active-color,@theme-black)}._30ST8somYJlrS3nF51nuW9 .desktop-dropdown .dropdown-menu .dropdown-item:hover{color:dycolor-internal(!dropdown-hover-color,@theme-black)}\n", ""]);

// exports
exports.locals = {
	"root": "_30ST8somYJlrS3nF51nuW9"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/gotu-vue-common/src/components/header/Header.scss
// module id = 913
// module chunks = 1